import React, { useEffect, useState } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { WelcomeContent } from '../components/WelcomeContent';
import { AddBrand } from '../components/AddBrand';
import { CreateCard } from '../components/CreateCard';
import { ContactButton } from '../components/ContactButton';
import { cloudStore } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
export function MainPage() {
    //(Function: ToTop) Go to top after switch page
    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    const [click, setclick] = useState(0)
    useEffect(() => {
        let clickvalue = click
        setclick(clickvalue + 1)
    }, [])

    const [expandForm, setExpand] = useState(false)
    const [cartMenuStyle, setCartMenuStyle] = useState({});
    const openCart = () => {
        let clickvalue = click
        setclick(clickvalue + 1)
        setExpand(true);
        setTimeout(() => { setCartMenuStyle({ transition: '0.3s', bottom: '0px' }) }, 50);
        setTimeout(() => { document.querySelector("#footer_forSmall").style.transition = "2.5s" }, 0);
        setTimeout(() => { document.querySelector("#footer_forSmall").style.bottom = "-5000px" }, 50);
    }

    const close = () => {
        document.querySelector("#footer_forSmall").style.transition = "0.5s"
        setTimeout(() => { document.querySelector("#footer_forSmall").style.bottom = "0px" }, 0);
        setTimeout(() => { setCartMenuStyle({ transition: '1s', bottom: '-5000px' }) }, 50);
        setTimeout(() => { setExpand(false) }, 200);
    }

    const [cartItemsDisplay, setCartItemsDisplay] = useState([]);
    const removeItem = (e) => {
        const value = e.target.dataset.value;
        const cartItems = JSON.parse(sessionStorage.getItem("WhatInCart"));
        const index = cartItems.findIndex((item) => item === value);
        if (index !== -1) {
            cartItems.splice(index, 1);
        }
        sessionStorage.setItem("WhatInCart", JSON.stringify(cartItems));
        updateCartItemsDisplay();
    }

    const addItem = (e) => {
        const value = e.target.dataset.value;
        let forStock = JSON.parse(sessionStorage.getItem("forStock")).filter((content) => {
            return Object.keys(content).some((key) => key === value);
        })
        let forStocknum = 0
        if (forStock.length > 0) {
            forStocknum = forStock[0][value]
        }
        let compareData = data.filter((content) => {
            return content["Product_Information"]["proname"] === (value);
        })
        let compareDataStock = compareData[0].LeftNum
        // console.log("forStocknum: ", forStocknum)
        // console.log("compareDataStock: ", compareDataStock)
        if (forStocknum + 1 > compareDataStock) {
            var tips = document.getElementById("snackbar");
            tips.style.zIndex = "3"
            tips.className = "show";
            setTimeout(() => { tips.className = tips.className.replace("show", "disappearFade"); }, 2000);
        } else {
            const cartItems = JSON.parse(sessionStorage.getItem("WhatInCart"));
            cartItems.push(value)
            sessionStorage.setItem("WhatInCart", JSON.stringify(cartItems));
            updateCartItemsDisplay();
        }
    }

    const [data, setdata] = useState([])
    useEffect(() => {
        getDocs(query(collection(cloudStore, "productData"), where("Product_Information", "!=", null)))
            .then((querySnapshot) => {
                const newInfoArray = querySnapshot.docs.map(doc => doc.data());
                newInfoArray.sort((a, b) => a["Product_Information"]["proname"].localeCompare(b["Product_Information"]["proname"], 'zh-Hans-CN'))
                    .sort((a, b) => b.OnFire - a.OnFire)
                    .sort((a, b) => (a.offShelves === b.offShelves) ? 0 : a.offShelves ? 1 : -1);
                setdata(newInfoArray)
            })
    }, [click])

    const updateCartItemsDisplay = () => {
        const cartItems = JSON.parse(sessionStorage.getItem("WhatInCart"));
        const array = [...new Set(cartItems)];
        let record = []

        if (data.length > 0) {
            record = array.sort().reduce((acc, currentItem) => {
                const count = cartItems.filter(item => item === currentItem).length;
                let oneData = data.filter((content) => {
                    return content.Product_Information.proname === currentItem
                })
                if (oneData.length > 0) {
                    acc.push({ [currentItem]: count, "price": oneData[0].Product_Information.proprice });
                }
                return acc;
            }, []);
        }
        sessionStorage.setItem("forStock", JSON.stringify(record))

        const eachcartItem = record.map((content, index) => {
            const keys = Object.keys(content);
            const itemName = keys.find((key) => key !== 'price');

            return (
                <div key={index}>
                    <div className="eachCartItem">
                        {itemName}: {content[itemName]}件
                        <span
                            className="removeItem material-symbols-outlined"
                            style={{ animation: "none", marginLeft: "10px" }}
                            onClick={(e) => addItem(e)}
                            data-value={itemName}
                        >
                            add
                        </span>
                        <span
                            className="removeItem material-symbols-outlined"
                            style={{ animation: "none" }}
                            onClick={(e) => removeItem(e)}
                            data-value={itemName}
                        >
                            remove
                        </span>
                        <div>单商品总价格：{content[itemName] * content["price"]}$</div>
                    </div>
                </div>
            );
        });

        setCartItemsDisplay(eachcartItem);
    }

    const [cartItemsChanged, setCartItemsChanged] = useState(false);
    useEffect(() => {
        const handleCartUpdate = () => {
            setCartItemsChanged((prev) => !prev);
        };
        window.addEventListener("cartUpdated", handleCartUpdate);
        return () => {
            window.removeEventListener("cartUpdated", handleCartUpdate);
        };
    });

    useEffect(() => {
        updateCartItemsDisplay();
    }, [cartItemsChanged, data]);

    const [filterContent, setfilter] = useState("")
    const filterTag = (e) => {
        let clickvalue = click
        setclick(clickvalue + 1)
        let value = e.target.dataset.value
        setfilter(value)
        const mainElement = document.querySelector(".cards");
        mainElement.style.animation = "none";
        mainElement.style.display = "none";
        void mainElement.offsetHeight;
        setTimeout(() => { mainElement.style.display = "flex"; mainElement.style.animation = "slideUp 0.8s ease"; }, 200);
    }

    const [totalPriceFinal, settotalPrice] = useState("")
    useEffect(() => {
        let array = JSON.parse(sessionStorage.getItem("forStock"))
        let totalPrice = 0
        for (let i = 0; i < array.length; i++) {
            let eachTotalPrice = Object.values(array[i])[0] * Object.values(array[i])[1]
            totalPrice = totalPrice + eachTotalPrice
        }
        settotalPrice(totalPrice.toFixed(2))
    })

    return (
        <div id='main_page'>
            <Navigation />
            <main>
                <WelcomeContent />
                {/* <h1 className="fixTips" style={{ textAlign: "center",marginBottom:"40px" }}>满70$免配送费，</h1> */}
                <div className='typeFilter'>
                    <ul>
                        <li data-value="All" onClick={(e) => filterTag(e)}>
                            <div data-value="All" onClick={(e) => filterTag(e)}>ALL</div>
                            所有零食
                        </li>
                        <li data-value="速食米饭" onClick={(e) => filterTag(e)}>
                            <img
                                draggable={false}
                                data-value="速食米饭"
                                onClick={(e) => filterTag(e)}
                                alt="自热米饭"
                                src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E8%87%AA%E7%83%AD%E7%B1%B3%E9%A5%AD.png?v=1678111958089" />
                            速食米饭
                        </li>
                        <li data-value="速食火锅" onClick={(e) => filterTag(e)}>
                            <img
                                draggable={false}
                                data-value="速食火锅"
                                onClick={(e) => filterTag(e)}
                                alt="自热火锅"
                                src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E8%87%AA%E7%83%AD%E7%81%AB%E9%94%85.png?v=1678111954797" />
                            速食火锅
                        </li>
                        <li data-value="肉食" onClick={(e) => filterTag(e)}>
                            <img
                                draggable={false}
                                data-value="肉食"
                                onClick={(e) => filterTag(e)}
                                alt="肉食"
                                src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E8%82%89%E9%A3%9F.png?v=1678111945393" />
                            肉食
                        </li>
                        <li data-value="速食汤面" onClick={(e) => filterTag(e)}>
                            <img
                                draggable={false}
                                data-value="速食汤面"
                                onClick={(e) => filterTag(e)}
                                alt="汤面"
                                src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E6%B1%A4%E9%9D%A2.png?v=1678111948426" />
                            速食汤面
                        </li>
                        <li data-value="休闲零食" onClick={(e) => filterTag(e)}>
                            <img
                                draggable={false}
                                data-value="休闲零食"
                                onClick={(e) => filterTag(e)}
                                alt="休闲零食"
                                src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E4%BC%91%E9%97%B2%E9%9B%B6%E9%A3%9F.png?v=1678111953049" />
                            休闲零食
                        </li>
                        <li data-value="饮料" onClick={(e) => filterTag(e)}>
                            <img
                                draggable={false}
                                data-value="饮料"
                                onClick={(e) => filterTag(e)}
                                alt="休闲零食"
                                src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E9%A5%AE%E6%96%99.png?v=1679052961991" />
                            饮料
                        </li>
                        <li data-value="手工甜点" onClick={(e) => filterTag(e)}>
                            <img
                                draggable={false}
                                data-value="手工甜点"
                                onClick={(e) => filterTag(e)}
                                alt="休闲零食"
                                src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E8%87%AA%E5%88%B6%E7%94%9C%E5%93%81.png?v=1679052588518" />
                            手工甜点
                        </li>
                        <li data-value="其他零食" onClick={(e) => filterTag(e)}>
                            <div data-value="其他零食" onClick={(e) => filterTag(e)}>?</div>
                            其他零食
                        </li>
                    </ul>
                </div>
                <h1 style={{ textAlign: "center",marginTop:"50px",marginBottom:"0" }}>点击商品，查看详情</h1>
                <AddBrand />
                <CreateCard filterContent={filterContent} carddata={data} />
            </main>
            {expandForm === true ?
                <>
                    <div className='forCloseFullSreen' onClick={close}></div>
                    <div className='cartMenu' style={cartMenuStyle}>
                        <div style={{ position: "sticky", top: "0px", zIndex: "1" }}>
                            <span
                                className="material-symbols-outlined forclose"
                                onClick={close}>expand_more
                            </span>
                        </div>

                        <div className='cartContent'>
                            {cartItemsDisplay}
                            <div>总价格：{totalPriceFinal}$</div>
                        </div>

                        <NavLink to="/summary">
                            <div className='button buttonForPay' onClick={topFunction}>
                                <div>清算时刻！</div>
                            </div>
                        </NavLink>
                        <div id="snackbar">抱歉，已达库存上限。</div>
                    </div>
                </> : null

            }
            {expandForm === false ?
                <>
                    <div className='cart material-symbols-outlined' onClick={openCart}>shopping_cart</div>
                </> : null

            }
            <ContactButton />
            <Footer />
        </div >
    );
}